<template>
  <div>
    
    <v-text-field v-bind="$attrs" v-if="getField(field)" :disabled="field ? field.DISABLED : false" :name="name || undefined" :id="id || undefined"
      :maxlength="field && field.MAXLEN ? field.MAXLEN : null" :rules="getValidators(field)"
      :label="!dense ? getLabel(field) : ''" :suffix="stripHtml(field.ADDHTML)" :value="value" :dense="dense"
      :hint="hint" :placeholder="placeholder" :persistentHint="persistentHint" :append-icon="appendIcon"
      @input="updateValue" @keydown="filterKey" @paste="onPaste" :autocomplete="$attrs.autocomplete || 'on'">
      <template v-slot:append>
        <v-tooltip right v-if="field.HELP && !dense">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">
              mdi-help-circle-outline
            </v-icon>
          </template>
          {{ field.HELP }}
        </v-tooltip>
      </template>

    </v-text-field>

  </div>

</template>

<script>
import fieldMixin from '../mixins/field';
import helperMixin from '../mixins/helper';

export default {
  name: 'aedTextField',
  inheritAttrs: false,
  mixins: [fieldMixin, helperMixin],
  props: {
    /**
     * Field object containing the configuration for the text field (e.g., label, validation rules).
     * @type {Object}
     */
    field: Object,

    /**
     * The current value of the text field.
     * @type {string}
     */
    value: String,
    dense: {
      type: Boolean,
      default: false
    },
    persistentHint: {
      type: Boolean,
      default: false
    },
    hint: String,
    placeholder: String,
    appendIcon: String,
    id:String,
    name:String,
  },
  data() {
    return {

    };
  },
  created() {
    // Prüfen, ob das 'field'-Objekt existiert
    if (this.field && this.field.VALUE) {
      console.log("aed text field default val", this.field.VALUE)
      const defaultValue = this.field.VALUE.toString();


      if (defaultValue !== undefined && defaultValue !== null && (this.value === '' || this.value === null || this.value === undefined)) {


        this.$emit('input', defaultValue);
      }
    }
  },
  methods: {
    updateValue(newValue) {
      this.$emit('input', newValue);
    },
    filterKey(e) {
      if (!this.field.PATTERN) return;

      // Wir erlauben Steuertasten (Backspace, Tab, Pfeile)
      if (e.ctrlKey || e.metaKey || e.key.length > 1) return;

      const match = this.field.PATTERN.match(/\[(.*?)\]/);
      if (match) {
        const regex = new RegExp(`[${match[1]}]`);
        if (!regex.test(e.key)) {
          e.preventDefault(); // Das Zeichen wird gar nicht erst geschrieben!
        }
      }
    },
    onPaste(e) {
      // Verhindert, dass Schrott per Copy-Paste reinkommt
      const clipboardData = e.clipboardData || window.clipboardData;
      const pastedData = clipboardData.getData('Text');
      const match = this.field.PATTERN.match(/\[(.*?)\]/);

      if (match) {
        const negativeRegex = new RegExp(`[^${match[1]}]`, 'g');
        if (negativeRegex.test(pastedData)) {
          e.preventDefault();
          const cleanData = pastedData.replace(negativeRegex, '');
          document.execCommand('insertText', false, cleanData);
        }
      }
    }

  },
};
</script>
